import React from 'react';

import { Divider } from 'redpoints-front-components/index';

const SocialMediaMessagesListItem = ({ textMessage }) => (
  <div className="social-media-messages__list__item">
    {textMessage}
    <Divider />
  </div>
);

export default SocialMediaMessagesListItem;
